// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__260Fk","customerTotals":"Footer_customerTotals__3ub1S","total":"Footer_total__2w9M9","graphic":"Footer_graphic__eibCW"};